
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="container max-w-4xl mx-auto py-8">
      <div className="mb-8">
        <Button
          variant="ghost"
          size="sm"
          className="mb-4"
          asChild
        >
          <Link to="/" className="flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            <span className="font-serif">Back to Home</span>
          </Link>
        </Button>
        
        <h1 className="text-3xl font-title text-primary mb-6">Privacy Policy</h1>
        
        <div className="prose prose-slate max-w-none font-body">
          <p className="text-muted-foreground text-sm mb-6">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">1. Introduction</h2>
          <p>
            Northwest Suburban Integration School District ("NWSISD," "we," "us," or "our") is committed to protecting the privacy of individuals who use our CEU Program Portal (the "Service"). This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li><strong>Personal Information:</strong> Name, email address, professional position, and school district affiliation.</li>
            <li><strong>Account Information:</strong> Login credentials and profile information.</li>
            <li><strong>Course Information:</strong> Records of courses you've registered for, attended, or completed.</li>
            <li><strong>Certificate Information:</strong> Records of certificates issued to you.</li>
            <li><strong>Usage Data:</strong> Information about how you use our Service, including access times and pages viewed.</li>
          </ul>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li>Provide, maintain, and improve our Service.</li>
            <li>Process and manage course registrations and certificates.</li>
            <li>Communicate with you about courses, updates, and other relevant information.</li>
            <li>Analyze usage patterns to improve user experience.</li>
            <li>Comply with legal and regulatory requirements.</li>
          </ul>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">4. Data Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          <ul className="list-disc pl-6 space-y-2 my-4">
            <li><strong>Service Providers:</strong> Third-party vendors who assist us in providing the Service.</li>
            <li><strong>Educational Institutions:</strong> When necessary for verifying course completion or credential requirements.</li>
            <li><strong>Legal Requirements:</strong> When required by applicable law, regulation, or legal process.</li>
          </ul>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">5. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">6. Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, such as the right to access, correct, or delete your data. To exercise these rights, please contact us at info@nwsisd.org.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">7. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy periodically. We will notify you of any significant changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
          </p>
          
          <h2 className="text-xl font-section text-primary mt-8 mb-4">8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mt-2">
            Northwest Suburban Integration School District<br />
            Email: info@nwsisd.org
          </p>
        </div>
      </div>
    </div>
  );
}
